import React from 'react';
import classNames from 'classnames';

import css from './IconCart2.module.css';

/**
 * Cart2 icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @returns {JSX.Element} SVG icon
 */
const IconCart2 = props => {
  const { className } = props;
  const classes = classNames(css.root, className);
  return (
    <svg width="68" height="71" viewBox="0 0 68 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63.75 60.7987C63.75 60.4069 63.4335 60.0903 63.0417 60.0903C62.6499 60.0903 62.3333 60.4069 62.3333 60.7987V63.9862H59.1458C58.754 63.9862 58.4375 64.3027 58.4375 64.6945C58.4375 65.0863 58.754 65.4028 59.1458 65.4028H62.3333V68.5903C62.3333 68.9821 62.6499 69.2987 63.0417 69.2987C63.4335 69.2987 63.75 68.9821 63.75 68.5903V65.4028H66.9375C67.3293 65.4028 67.6458 65.0863 67.6458 64.6945C67.6458 64.3027 67.3293 63.9862 66.9375 63.9862H63.75V60.7987Z"
        fill="#734D70"
      />
      <path
        d="M29.9035 4.14354C30.6236 2.75048 30.0806 1.03868 28.6993 0.318538C27.3181 -0.401601 25.5944 0.141454 24.8743 1.5227L13.8833 22.6665H3.77778C1.68819 22.6665 0 24.3546 0 26.4442C0 28.5338 1.68819 30.222 3.77778 30.222L9.90486 54.7185C10.7431 58.0831 13.7653 60.4442 17.2361 60.4442H50.7639C54.2347 60.4442 57.2569 58.0831 58.0951 54.7185L64.2222 30.222C66.3118 30.222 68 28.5338 68 26.4442C68 24.3546 66.3118 22.6665 64.2222 22.6665H54.1167L43.1257 1.5227C42.4056 0.141454 40.6937 -0.401601 39.3007 0.318538C37.9076 1.03868 37.3764 2.75048 38.0965 4.14354L47.7299 22.6665H20.2701L29.9035 4.14354ZM22.6667 35.8887V47.222C22.6667 48.2609 21.8167 49.1109 20.7778 49.1109C19.7389 49.1109 18.8889 48.2609 18.8889 47.222V35.8887C18.8889 34.8498 19.7389 33.9998 20.7778 33.9998C21.8167 33.9998 22.6667 34.8498 22.6667 35.8887ZM34 33.9998C35.0389 33.9998 35.8889 34.8498 35.8889 35.8887V47.222C35.8889 48.2609 35.0389 49.1109 34 49.1109C32.9611 49.1109 32.1111 48.2609 32.1111 47.222V35.8887C32.1111 34.8498 32.9611 33.9998 34 33.9998ZM49.1111 35.8887V47.222C49.1111 48.2609 48.2611 49.1109 47.2222 49.1109C46.1833 49.1109 45.3333 48.2609 45.3333 47.222V35.8887C45.3333 34.8498 46.1833 33.9998 47.2222 33.9998C48.2611 33.9998 49.1111 34.8498 49.1111 35.8887Z"
        fill="#734D70"
      />
    </svg>
  );
};

export default IconCart2;
